// extracted by mini-css-extract-plugin
module.exports = {"detailsForm":"purchaser-details_detailsForm__2I4-F","col":"purchaser-details_col__gLih9"};